import { usePolicyholder, usePrincipal } from '../../../application/authentication'
import { AccountValidationStatus, Proposer } from '../../../domain'
import { useApiErrorHandlingAsyncCallback } from '../../auth'
import { hasChanges } from './helpers'

export * from './data'

export const usePolicyholderAdjustment = (onComplete?: () => Promise<void> | void) => {
  const { apiClient } = usePrincipal()
  const { policyholder, setPolicyholder } = usePolicyholder()

  return useApiErrorHandlingAsyncCallback(async (data: Partial<Proposer>) => {
    if (hasChanges(policyholder, data)) {
      setPolicyholder(await apiClient.updateProposer(data))
    }

    await onComplete?.()
  })
}

export const useAccountValidation = (onSuccess?: () => void, onConflict?: () => void) => {
  const { apiClient } = usePrincipal()

  return useApiErrorHandlingAsyncCallback(async () => {
    const accountValidation = await apiClient.validateUserAccount('Final Mile')

    switch (accountValidation.validationStatus) {
      case AccountValidationStatus.OK:
        onSuccess?.()
        break
      case AccountValidationStatus.CONFLICT:
        onConflict?.()
        break
    }
  })
}
